import Vue from 'vue'

const state = {
    menu: [],
    sistemas: []
}

const getters = {
    getMenu: state => {
        return state.menu;
    },

    getSistemas:  state => {
        return state.sistemas;
    }
}

const mutations = {
    setMenu: (state, payload) => {
        state.menu = payload;
    },

    setSistemas: (state, payload) => {
        state.sistemas = payload;
    }
}

const actions = {
    setMenu({ commit, state, rootState }, payload) {
        commit('setMenu', payload)
    },

    setSistemas({ commit, state, rootState }, payload) {
        commit('setSistemas', payload)
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}